export default {
  title: 'Pisteet ja alennukset',
  store_credit: 'Kauppasaldo',
  points_balance: 'Pistesaldo',
};
